import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ProvidersCardsContainer = styled(Box)`
  padding: ${(props) => props.theme.spacing['3']};
  box-shadow: ${(props) => props.theme.box_shadow.card};
`
export const CustomValue = styled.small`
  font-size: ${(props) => props.theme.typography.body_size.normal};
  font-weight: 500;
`

export const Link = styled.a`
  display: flex;
`
